import { Attr, BelongsTo, Model } from "spraypaint";
import { ApplicationStatus } from "../types";
import ApplicationRecord from "./ApplicationRecord";
import Candidate from "./Candidate";
import Engagement from "./Engagement";
import Job from "./Job";

function backToLink() {
  return `back_to=${encodeURIComponent(window.location.href)}`;
}

@Model()
class Application extends ApplicationRecord {
  static jsonapiType = "applications";

  @Attr() candidateId: string;

  @Attr() cvReadCount: number;

  @Attr() cvDownloadCount: number;

  @Attr() jobId: number;

  @Attr() engagementId: number;

  @Attr() candidateDesiredSalary: number;

  @Attr() status: ApplicationStatus;

  @Attr() feedbackOverdue: boolean;

  @Attr({ persist: true }) createdAt: Date;

  @Attr({ persist: true }) updatedAt: Date;

  @Attr() lastAction: string;

  @BelongsTo(Job) job: Job;

  @BelongsTo(Engagement) engagement: Engagement;

  @BelongsTo(Candidate) candidate: Candidate;

  get viewLink() {
    return `/employer/jobs/${this.jobId}/engagements/${
      this.engagementId
    }/applications/${this.id}?${backToLink()}#/information`;
  }

  get recruiterViewLink() {
    return `/recruiter/jobs/${this.jobId}/engagements/${
      this.engagementId
    }/applications/${this.id}?${backToLink()}#/information`;
  }

  get previewCvLink() {
    return `/employer/applications/${this.id}/preview_cv?${backToLink()}`;
  }
}

export default Application;
